import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { testimonials } from '@/mocks/home';

export default function AboutPage() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '久久久',
    url: 'https://www.jiujiujiu.com',
    description: '久久久代表持久、稳定与长效的极致追求，提供经久耐用的产品与持续有效的服务。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
      email: 'service@jiujiujiu.com',
    },
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressLocality: '杭州市',
      addressRegion: '浙江省',
      streetAddress: '余杭区未来科技城久久久大厦',
    },
  };

  const webpageSchema = {
    name: '关于我们 - 久久久',
    description: '了解久久久品牌故事、品质理念与联系方式。久久久代表持久、稳定与长效的极致追求。',
    url: 'https://www.jiujiujiu.com/about',
  };

  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="Organization" data={orgSchema} />
      <SchemaOrg type="WebPage" data={webpageSchema} />

      <Navbar />

      <main className="pt-24 md:pt-28">
        <div className="max-w-[900px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          <div className="mb-10 md:mb-12" id="brand">
            <p className="text-xs font-label tracking-[0.15em] uppercase text-foreground-500 mb-3">关于久久久</p>
            <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-6">持久稳定的品质体验，经久不衰的信赖之选</h1>
          </div>

          <section className="mb-14 md:mb-16">
            <div className="aspect-[16/7] rounded-xl overflow-hidden mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20modern%20brand%20headquarters%20office%20with%20natural%20textures%2C%20soft%20diffused%20lighting%2C%20cream%20beige%20and%20warm%20wood%20tones%2C%20elegant%20workspace%2C%20team%20collaboration%20atmosphere%2C%20editorial%20photography%2C%20professional%20composition&width=1600&height=700&seq=about-hero-01&orientation=landscape"
                alt="久久久品牌"
                className="w-full h-full object-cover rounded-xl"
              />
            </div>
            <div className="prose max-w-none">
              <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-4">品牌故事</h2>
              <p className="text-foreground-600 leading-relaxed mb-4">
                久久久诞生于对"持久品质"的极致追求。在快消品文化盛行的时代，我们选择了一条不同的路——用心做好每一件产品，让它们陪伴用户更长的时间。久久久相信，真正的好产品不需要频繁更换，经久耐用本身就是最大的价值。
              </p>
              <p className="text-foreground-600 leading-relaxed mb-4">
                从创立之初，久久久就确立了"三好原则"：好材质、好工艺、好服务。我们只选用上等原材料，传承匠心制造工艺，并提供远超行业标准的超长质保服务。久久久的每一件产品，都经过远超行业标准的实验室测试，确保经得起时间的检验。
              </p>
              <p className="text-foreground-600 leading-relaxed">
                久久久不仅是一个品牌，更是一种生活态度——选择更少但更好的物品，让每一件都经得起时间的考验。我们倡导"少即是多、精即是久"的品质生活理念，致力于成为用户心中经久不衰的信赖之选。
              </p>
            </div>
          </section>

          <section className="mb-14 md:mb-16">
            <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-6">核心价值</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {[
                { icon: 'ri-shield-star-line', title: '品质至上', desc: '从原材料到成品，久久久建立了全程可追溯的品质管控体系。每一件产品上市前都经过远超行业标准的严苛测试，确保品质始终如一。' },
                { icon: 'ri-time-line', title: '经久耐用', desc: '久久久产品的设计寿命远超行业平均水准。我们选用高规格材质，采用精湛工艺，让产品真正实现"久久久"的品牌承诺。' },
                { icon: 'ri-hand-heart-line', title: '用户为本', desc: '久久久始终以用户需求为核心，坚持"敢承诺、能兑现"的服务原则，用超长质保和优质售后赢得用户信赖。' },
                { icon: 'ri-leaf-line', title: '绿色可持续', desc: '久久久践行环保理念，坚持使用可回收材料、减少过度包装。经久耐用本身就是最大的环保——减少更换频率，降低资源消耗。' },
              ].map((v) => (
                <div key={v.title} className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100/80 mb-4">
                    <i className={`${v.icon} text-xl text-accent-700`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">{v.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-14 md:mb-16" id="testimonials">
            <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-6">用户口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                  <div className="flex gap-1 mt-4 text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-14 md:mb-16 pb-12 md:pb-16" id="contact">
            <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-6">联系我们</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100/80 shrink-0">
                    <i className="ri-phone-line text-xl text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950 mb-1">服务热线</p>
                    <p className="text-sm text-foreground-600">400-888-9999</p>
                    <p className="text-xs text-foreground-400">7×24小时在线服务</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100/80 shrink-0">
                    <i className="ri-mail-line text-xl text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</p>
                    <p className="text-sm text-foreground-600">service@jiujiujiu.com</p>
                    <p className="text-xs text-foreground-400">工作日2小时内回复</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100/80 shrink-0">
                    <i className="ri-map-pin-line text-xl text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950 mb-1">公司地址</p>
                    <p className="text-sm text-foreground-600">浙江省杭州市余杭区未来科技城久久久大厦</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100/80 shrink-0">
                    <i className="ri-wechat-line text-xl text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950 mb-1">微信公众号</p>
                    <p className="text-sm text-foreground-600">久久久品质生活</p>
                    <p className="text-xs text-foreground-400">关注获取最新资讯</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl p-6 md:p-8">
                <h3 className="text-base font-semibold text-foreground-950 mb-4">在线留言</h3>
                <p className="text-sm text-foreground-500 mb-4">如需咨询或反馈，请拨打服务热线 400-888-9999 或发送邮件至 service@jiujiujiu.com，久久久客服团队将竭诚为您服务。</p>
                <div className="space-y-3">
                  <div className="text-sm text-foreground-600 flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-green-500"></i>
                    <span>7天无理由退换货</span>
                  </div>
                  <div className="text-sm text-foreground-600 flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-green-500"></i>
                    <span>超长质保承诺</span>
                  </div>
                  <div className="text-sm text-foreground-600 flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-green-500"></i>
                    <span>48小时极速换新</span>
                  </div>
                  <div className="text-sm text-foreground-600 flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-green-500"></i>
                    <span>免费上门取件</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}